import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col } from "react-bootstrap";
import ProductService from "../services/Product";
import { useNavigate, useParams } from "react-router-dom";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import DefaultImage from "../assets/images/productDefault.png";
import { Heart } from "react-feather";
import Loader from "../component/Loader";
import SingleProduct from "../component/UnlockGiftVoucher";
import CartService from "../services/Cart";
import AlertMsg from "../component/AlertMsg";
import WishListOutLine from "../assets/images/heartOutline.png";
import OtherService from "../services/Other";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import OTPBox from "../component/OTPBox";
import { Link } from "react-router-dom";
import PrimaryOutLineButton from '../component/PrimaryOutLineButton'
import ModalComponent from '../component/ModalComponent'
import toast from "react-hot-toast";
const UGV = () => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState("");
  const [indexdata, setIndexData] = useState(true);
  const [isProductData, setIsProductData] = useState([]);
  const [issearchText, setIsSearchText] = useState("");
  const [isLoginSuccess, setIsLoginSuccess] = useState({
    isLogin: true,
    heading: "",
    text: "",
  });
  const [isWishListSuccess, setIsWishListSuccess] = useState({
    isLogin: true,
    heading: "",
    text: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [showWishListAlert, setShowWishListAlert] = useState(false);

  const [token, setToken] = useState("");
  const [loadingst, setLoadingst] = useState(false);
  const [productList, setProductList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [pin1, setPin1] = useState("");
  const [pin2, setPin2] = useState("");
  const [pin3, setPin3] = useState("");
  const [pin4, setPin4] = useState("");
  const [pin5, setPin5] = useState("");
  const [pin6, setPin6] = useState("");
  const otpValueFromField = Number(pin1 + pin2 + pin3 + pin4 + pin5 + pin6);
  // const { product_id,category_id} = useParams();
  // const {catgryId } = useParams();
  // const [image,setImage]=useState("https://pixabay.com/photos/hands-holding-smartphone-chatting-1853302/")
  const [myimage, setMyimage] = useState(
    "https://cdn.pixabay.com/photo/2016/11/23/14/44/hands-1853302_1280.jpg"
  );

  const getPEgvList = async (tk) => {

    setLoadingst(true);

    OtherService.egvList(tk)
      .then((res) => {
        setLoadingst(false);
        console.log("res===>>", res);
        if (res.response_code === 200) {

         setProductList(res.data);
        } else {
          setProductList([]);
          const obj = res.response.error;
        }

      })
      .catch((err) => {
        setLoadingst(false);
      });
  };

  //   const verifyOtp = (pinArray) => {
  const verifyOtp = () => {
    const payload = {
      sku_id: selectedItem?.id,
      otp: otpValueFromField,
      is_accpted_tnc: selectedItem?.is_accpted_tnc, 
    };
    console.log("payload", payload);
    // alert(productList[indexdata].id);
    OtherService.egvUnlock(payload)
      .then((res) => {
        //   setUnclockLoadingst(false);
        setResponse(res)

        // alert(JSON.stringify(res));
        // alert(res.errorMessage.reason.response.reason);
        // alert(res.statusCode);
        if (res.response_code == 200) {
          toast.success(res.message || "EGV has been successfully unlocked");
          handleClose();
          setTimeout(()=>{
            setResponse("")
          },5000)

          // alert(JSON.stringify(res));
          //       const updatedProductList = [...productList];

          // updatedProductList[currentIdx].is_code_visible = 1;
          // updatedProductList[currentIdx].is_accpted_tnc = 1;
          // setShowNotify(true);
          // setProductList(updatedProductList);
          // setcurrentIdx('');
          // setcurrentItem('');
          // setActionStatus({isSuccess: true, heading: "Thank You", describe:"EGV has been successfully unlocked"})
        } else {
          toast.error(res.message || "Failed to unlock EGV");
          setTimeout(()=>{
            setResponse("")
          },5000)
          //       setcurrentIdx('');
          // setcurrentItem('');
          // setShowNotify(true)
          //   setActionStatus({isSuccess: false, heading: "Sorry", describe:res.errorMessage.reason.response.reason})

          const obj = res.response.error;
          // alert(JSON.stringify(res));
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error("Failed to unlock EGV");
        //   setUnclockLoadingst(false);
      });
  };

  useEffect(() => {
    const usertoken = localStorage.getItem("access_token");

    setToken(usertoken);
    getPEgvList(usertoken);
    //  alert(usertoken)
  }, [response]);
  // unlockCard(productList,index)

  // Unlock card code function new
  const unlockCard = (productList, index) => {
    // console.log("productList[index]", productList[index]);
    setSelectedItem(productList[index]);
    //  setUnclockLoadingst(true);

    OtherService.egvOTPSend(productList[index].id)
      .then((res) => {
        //  setUnclockLoadingst(false);

        if (res.response_code === 200) {
          handleShow();
          
          //  alert(1)
          //  setcurrentIdx(index);
          //  setOpenOTP(true);
          //  setcurrentItem(item);
          //     setActionStatus({isSuccess: true, heading: "Product added to wishlist", describe:"Product has been successfully added to wishlist"})
          // setTimeout(()=>{
          //   setShowNotify(false)
          // },3000)
        } else {
          // alert(2)
          //  setShowNotify(true);
          //  setActionStatus({isSuccess: false, heading: "Faild", describe:"Faild to send OTP"})
          //    const obj = res.response.error;
          //    setTimeout(()=>{
          //      setShowNotify(false)
          //    },3000)
        }

      })
      .catch((err) => {
        //  setUnclockLoadingst(false);
      });
  };
  //  End
  // otp verification start

  // otp verify end

  function raffunction() {
  }

  return (
    <>
      {/* {loading && <Loader />} */}

      <BreadCrumbSecttion pageTitle="Unlock Gift Card" currentPageName="Unlock Gift Card" />
      <section className="padTop50">
        <Container className="egvWrap">
          <Row>
            <Col>
              {productList.length > 0 ? (
                <div></div>
              ) : (
                <div>No data found</div>
              )}
            </Col>
          </Row>
          <Row>
            {/* <Col>
                     <div className='alertBoxWrap'>
                                            {showAlert && <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                                heading={isLoginSuccess.heading}
                                                text={isLoginSuccess.text}
                                            />
                                            }
                                            </div>
                                            <div className='alertBoxWrap'>
                                            {showWishListAlert && <AlertMsg alertBoxColor={isWishListSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                                heading={isWishListSuccess.heading}
                                                text={isWishListSuccess.text}
                                            />
                                            }
                                            </div>
                     </Col> */}
          </Row>
          <Row>
            {/* {isProductData?.map((item,index)=>{
                        const{product_name,short_desc,price,product_images,product_id,catalog_id,category_id} = item
                        const 
                         = product_images.length > 0 ? product_images[0].product_image : DefaultImage;
                        
                        return( */}

            <Modal show={show} onHide={handleClose} animation={false}>
              <Modal.Header closeButton>
              <Modal.Title>Enter your OTP</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="registrationTopText">
                  <div className="otpBox">
                    <OTPBox
                      pin1={pin1}
                      pin2={pin2}
                      pin3={pin3}
                      pin4={pin4}
                      pin5={pin5}
                      pin6={pin6}
                      setPin1={setPin1}
                      setPin2={setPin2}
                      setPin3={setPin3}
                      setPin4={setPin4}
                      setPin5={setPin5}
                      setPin6={setPin6}
                    />
                  </div>
                  {/* <div className='resendText'>
  <Link className="linkColor" onClick={handleOTPSubmit}><u>Submit</u></Link>
</div> */}

</div>
<Col xs = {12} className='mt-3 '>
             {/* <AlertMsg alertBoxColor={'successAlert'}
                                            heading={isLoginSuccessHeading}
                                            text={isLoginSuccessText}/> */}
                                             {response!="" && 
              
             <AlertMsg alertBoxColor={response.response_code == 200 ? 'successAlert' : 'FailedAlert'}
                                            heading={"OTP"}
                                            // text={response.errorMessage.reason.response.reason}/>
                                            text={response.response_code == 200 ?"OTP submitted successfully": "provided OTP is not belong to given customer."}/>
                        
            
             }         
                       
            </Col>

               
              </Modal.Body>
              {/* {showAlert &&  */}
              
              <Row>
             
            </Row>
             {/* } */}
              <Modal.Footer>
                {/* <Button variant="secondary" onClick={handleClose}>
                  Close
                </Button> */}
         <div className="d-flex justify-content-between align-items-center">
                   <PrimaryGradientButton buttonText="Close" onClick={handleClose} />
                   </div>
                {/* <Button variant="primary" onClick={verifyOtp}>
                  Save Changes
                </Button> */}
                     <div className="d-flex justify-content-between align-items-center">
                <PrimaryOutLineButton outlinebuttonText="Submit" onClick={verifyOtp} />
                </div> 
              </Modal.Footer>
            </Modal>

            {productList.length > 0 &&
              productList.map((mydatda, index) => {
                return (
                  <Col xs={12} sm={6} md={4} lg={3} key={index}>
                    <SingleProduct
                      heart={WishListOutLine}
                      onClickWishList={() =>
                        //  handleWishList(product_id)
                        raffunction()
                      }
                      productName={mydatda.title}
                      // cuponeCode={"CuponCode- " + mydatda.sku_code}
                      unblockBtnvisiblity={mydatda.unblockBtnvisiblity}
                      // cuponeCode={"CuponCode- " + "xxxxxx"}

                      cuponeCode={
                        (mydatda.is_accpted_tnc == null &&
                          mydatda.is_code_visible == null) ||
                        !mydatda.activation_pin
                          ? "cuponeCode= xxxxxx"
                          : "cuponeCode -" + mydatda.activation_pin
                      }
                      price={mydatda.point}
                      tdsTxt="(*10% TDS may be applicable)"
                      //   getTxt="Get within 10 days"
                      oneButtom={true}
                      hartpicenable={false}
                      productImage={mydatda.image}
                      onClick={
                        () => handleShow()
                        // handleViewDetails(product_id, category_id)
                      }
                      onClickCart={() => {
                        unlockCard(productList, index);
                        setIndexData(index);
                      }}
                    />
                  </Col>
                );
              })}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default UGV;
